import { Popover as AntPopover, PopoverProps } from "antd";
import styled from "styled-components";

export const Popover: typeof AntPopover = styled(AntPopover)<PopoverProps>``;
